// Reactアプリケーションのエントリーポイント
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';  // Tailwind CSSのスタイルをインポート
import App from './App';

// React 18の新しいAPIを使用
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
